import React from 'react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { CollapsibleCard } from '../ui/collapsible-card';
import { Award, ChevronRight } from 'lucide-react';
import FramedAvatar from '../FramedAvatar';

const LeaderboardPreview = ({ contributors, onNavigate, loading }) => {
  return (
    <CollapsibleCard
      id="leaderboard"
      title="Top contributeurs"
      mobileDefaultCollapsed
      icon={<div className="p-1.5 rounded-lg bg-purple-500/20"><Award className="w-4 h-4 text-purple-500" /></div>}
      className="card-premium"
      headerRight={
        <Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); onNavigate('/leaderboard'); }} className="hover-lift">
          Classement <ChevronRight className="w-4 h-4 ml-1" />
        </Button>
      }
    >
        <div className="space-y-2">
          {contributors.length > 0 ? (
            contributors.map((contributor, index) => (
              <div 
                key={contributor.id} 
                className={`flex items-center gap-3 p-2.5 rounded-lg transition-all hover:scale-[1.02] cursor-pointer ${
                  index === 0 ? 'bg-gradient-to-r from-yellow-500/10 to-amber-500/5 border border-yellow-500/20' :
                  index === 1 ? 'bg-gradient-to-r from-gray-400/10 to-gray-500/5 border border-gray-400/20' :
                  'bg-gradient-to-r from-orange-500/10 to-amber-600/5 border border-orange-500/20'
                }`}
                onClick={() => onNavigate(`/members/${contributor.id}`)}
                data-testid={`leaderboard-item-${index}`}
              >
                <span className="text-lg">{index === 0 ? '👑' : index === 1 ? '🥈' : '🥉'}</span>
                <FramedAvatar
                  src={contributor.avatar_url}
                  fallback={`${contributor.first_name?.[0]}${contributor.last_name?.[0]}`}
                  frame={contributor.profile_frame}
                  role={contributor.role}
                  seniority={contributor.seniority}
                  size="md"
                />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium truncate">{contributor.first_name} {contributor.last_name}</p>
                  <p className="text-xs text-muted-foreground">Niv.{contributor.level || 1} • {contributor.points || 0} pts</p>
                </div>
                <Badge variant="outline" className="text-xs">#{index + 1}</Badge>
              </div>
            ))
          ) : (
            [1, 2, 3].map((i) => (
              <div key={i} className="flex items-center gap-3 p-2 bg-secondary/30 rounded-lg">
                <div className="h-8 w-8 bg-secondary/50 rounded-full animate-pulse" />
                <div className="flex-1">
                  <div className="h-4 bg-secondary/50 rounded animate-pulse" />
                </div>
              </div>
            ))
          )}
          <Button variant="ghost" className="w-full text-sm mt-2 hover-lift" onClick={() => onNavigate('/leaderboard')}>
            Voir le classement complet
          </Button>
        </div>
    </CollapsibleCard>
  );
};

export default LeaderboardPreview;
